<template>
    <div id="content">
      <div id="pageContent">
        <div class="pageHeader">
          <div class="white flex flex-column hcenter" style="font-family: TruenoBd;padding-left: 10%;height: 100%">
            <div class="pageTitle">公司动态</div>
            <div class="subPageTitle">/COMPANY DYNAMICS</div>
          </div>
        </div>
        <div class="tabs flex justify-spaceBetween vcenter">
          <div class="flex1">
            <a class="tab pointer" :class="{'active': active == 'company'}" @click="active = 'company'">公司动态</a>
            <a class="tab pointer ml8" :class="{'active': active == 'hangye'}" @click="active = 'hangye'">行业动态</a>
          </div>
          <div class="flex1 t-right hidden-xs">
            <span>您的位置：</span>
            <a href="/">首页 </a>
            <span>&gt; 公司动态</span>
          </div>
        </div>
        <div class="p6" v-if="active == 'company' && newsList && newsList.length">
          <div v-for="(item, index) of newsList" :key="index" class="ten_news_list ten_news_items pointer" data-lazy="10" data-lazy-threshold="0.9">
            <div class="ten_news_item flex hcenter" :class="{'mt4': index > 0}" @click="$router.push({ path: '/newsDetail', query: { id: item.article_id }})">
              <div class="ten_news_item_img">
                <div class="pointer">
                  <div class="ten_img">
                    <img :src="item.article_pic_big">
                  </div>
                </div>
              </div>
              <div class="ten_news_item_txt ml4 flex flex-column justify-spaceBetween">
                <div>
                  <h3>{{item.article_title}}</h3>
                  <p>{{item.article_intro}}</p>
                </div>
                <div class="ten_tagline">
                  <div style="padding-top: 3px">{{ parseTime(item.article_addtime, '{y}-{m}-{d}') }}</div>
                </div>
              </div>
              <div class="divider hidden-md hidden-sm hidden-xs"></div>
              <div style="height: 210px" class="flex vcenter arrow-bac hidden-md hidden-sm hidden-xs">
                <div class="arrow-border">
                  <div class="arrow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p6" v-else-if="active == 'hangye' && newsList_2 && newsList_2.length">
          <div v-for="(item, index) of newsList_2" :key="index" class="ten_news_list ten_news_items pointer" data-lazy="10" data-lazy-threshold="0.9">
            <div class="ten_news_item flex hcenter" :class="{'mt4': index > 0}">
              <div class="ten_news_item_img">
                <div class="pointer">
                  <div class="scale">
                    <img :src="item.article_pic_big">
                  </div>
                </div>
              </div>
              <div class="ten_news_item_txt ml4 flex flex-column justify-spaceBetween">
                <div>
                  <h3>{{item.article_title}}</h3>
                  <p>{{item.article_intro}}</p>
                </div>
                <div class="ten_tagline">
                  <div style="padding-top: 3px">{{ parseTime(item.article_addtime, '{y}-{m}-{d}') }}</div>
                </div>
              </div>
              <div class="divider hidden-md hidden-sm hidden-xs"></div>
              <div style="height: 210px" class="flex vcenter arrow-bac hidden-md hidden-sm hidden-xs">
                <div class="arrow-border">
                  <div class="arrow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { parseTime } from "@/utils/data";
export default {
  name: 'About',
  data() {
    return {
      active: 'company',
      newsList: [
        {
          article_addtime: "1652887710",
          article_id: "421",
          article_intro: "1",
          article_pic_big: "http://www.yixilife.com/admin/upload/attatch/2/165288778574433.png",
          article_title: "合成生物学领域又一应用突破，「一兮生物」生物合成母乳低聚糖HMO"
        }
      ],
      newsList_2: [],
    }
  },
  created() {
    this.getNewList();
  },
  methods: {
    // go(name) {
    //   var scrollTop = document.getElementById(name).scrollTop;
    // }
    async getNewList() {
      let res = await request({
        url: `/api.php?app=ajax&app_act=newsList&folder_id=62`,
        method: "get",
      });
      this.newsList = res.data?res.data.data : [];
      let res2 = await request({
        url: `/api.php?app=ajax&app_act=newsList&folder_id=63`,
        method: "get",
      });
      this.newsList_2 = res2.data?res2.data.data : [];
      // this.newsList.forEach(item => {
      //   item.article_pic_big = require(`${item.article_pic_big}`);
      // })
    },
    parseTime,
  }
}
</script>

<style lang="scss" scoped>
    h3 {
      margin-top: 0px;
      margin-bottom: 16px;
      font-size: 29px;
    }
    .pageHeader{
        overflow: hidden; width: 100%; height: 494px;
        background-image: url("../assets/news/news1.png");
        background-position: 50% 50%;
    }
    .ten_tagline {
      font-size: 24px;
      font-weight: 400;
      color: rgba(17, 29, 43, 0.2);
    }
    .ten_news_items { margin: 0 auto;max-width: 1150px; }
    .ten_news_item{  display: flex; padding: 28px; }
    .ten_news_item:hover{ box-shadow: 0px 0px 25px 0px rgba(17,29,43,0.16);border-radius: 10px; }
    .ten_news_item h3{
      font-weight: 600;
      font-size: 22px;
    }
    .ten_news_item_txt{ width: calc(60% - 72px); height: 210px }
    .ten_news_item_img{width: calc(40% - 0px); max-width: 364px;}

    .ten_news_item_txt h3{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      line-height: 1.5;
    }
    .ten_news_item_txt p{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        font-size: 19px;
        font-weight: 400;
        color: rgba(17, 29, 43, 0.5);
        line-height: 28px;
    }
    a {
      text-decoration: none;
      color: inherit;
      cursor: pointer;
    }
    .ten_img {
      img {
        width: 100%;
        height: 210px;
        max-width: 485px;
        object-fit: cover;
      }
    }
    .divider {
      margin: 0px 48px 8px 96px;
      width: 0.6px;
      height: 200px;
      background-color: rgba(17, 29, 43, 0.1);
    }
    .arrow-border {
      width: 100px;
      height: 40px;
      border: 1px solid rgba(17, 29, 43, 0.34);
      .arrow {
        background: url("../assets/news/arrow.svg") 50% 50% no-repeat no-repeat;
        height: 100%;
      }
    }
    .arrow-border:hover {
      background: #00BD89;
      .arrow {
        background: url("../assets/news/arrow2.svg") 50% 50% no-repeat no-repeat;
      }
    }
    @media screen and (max-width: 960px)  {
      .ten_news_item {
        flex-direction: column;
        .ten_news_item_txt{ width: calc(80% - 0px);height: 168px;margin-top:24px;margin-left: 0px; }
        .ten_news_item_img{width: calc(80% - 0px); max-width: 485px;}
        align-items: center;
      }
    }
    @media screen and (max-width: 1200px)  {
      .ten_news_item_txt{ width: calc(60% - 72px); }
    }
    @media screen and (max-width: 768px)  {
      .ten_news_item_txt p {
        font-size: 14px;
      }
      .ten_news_item_txt h3 {
        font-size: 16px;
      }
      .ten_tagline {
        font-size: 20px;
      }
      .ten_news_item{ box-shadow: 0px 0px 25px 0px rgba(17,29,43,0.16);border-radius: 10px; }
    }
</style>



// WEBPACK FOOTER //
// src/views/news.vue